import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import { ProjectsIcon } from '@atlaskit/temp-nav-app-icons/projects';

import type { GlobalShortcutsItem } from '../../types';

import { messages } from './messages';

export default function projects(fallbackUrl: () => string): GlobalShortcutsItem {
	return {
		icon: <ProjectsIcon size="20" />,
		label: <FormattedMessage {...messages.label} />,
		fallbackUrl,
	};
}
